import {
  useCappsRenterDocumentsWebApiHandler_addRequiredDocuments,
  useCappsRenterDocumentsWebApiHandler_attachRequiredDocuments,
  useCappsRenterDocumentsWebApiHandler_detachRequiredDocument,
} from '@zg-rentals/ts-capps-client-react-query';
import { DOCUMENT_POOL_TAG } from '../constants/applicationsConstants';
import { RENTAL_APPLICATION_TAG } from './useRentalApplication';

const REQUIRED_DOCUMENT_INVALIDATES = [RENTAL_APPLICATION_TAG, DOCUMENT_POOL_TAG];

export function useAddRequiredDocuments() {
  return useCappsRenterDocumentsWebApiHandler_addRequiredDocuments({
    meta: {
      context: { api: 'cappsRenterDocuments', details: 'addRequiredDocuments' },
      invalidates: REQUIRED_DOCUMENT_INVALIDATES,
    },
  });
}

export function useAttachRequiredDocuments() {
  return useCappsRenterDocumentsWebApiHandler_attachRequiredDocuments({
    meta: {
      context: { api: 'cappsRenterDocuments', details: 'attachRequiredDocuments' },
      invalidates: REQUIRED_DOCUMENT_INVALIDATES,
    },
  });
}

export function useDetachRequiredDocument() {
  return useCappsRenterDocumentsWebApiHandler_detachRequiredDocument({
    meta: {
      context: { api: 'cappsRenterDocuments', details: 'detachRequiredDocument' },
      invalidates: REQUIRED_DOCUMENT_INVALIDATES,
    },
  });
}
